import * as faceapi from 'face-api.js';
import logo from './logo.svg';
import './App.css';
import { useState , createContext ,useEffect ,useRef,Provider  } from 'react';
import { SnackbarProvider , enqueueSnackbar } from 'notistack';
import  CustomAppBar  from './components/AppBar';
import  AppBody from './components/AppBody';
import ResponsiveDrawer from './components/AppDrawer';
import BottomNav from './components/BottomNav';
// import { AppGlobalContext } from './context';
import {open_db} from './db';
import * as volanteer from './volanteer';
import {Provider as ReduxProvider} from 'react-redux'
import {createStore} from 'redux'
import store from './store';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

export const AppGlobalContext=createContext();

function App() {
  const [progressCircleState,setProgressCircleState]=useState('none')
  const [pageName,setPageName]=useState('Login')
  const [drawerState, setdrawerState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [modelsLoaded, setModelsLoaded] = useState(false);
  const [captureVideo, setCaptureVideo] = useState(false);
  let render_count=0;
  window.faceapi=faceapi;
  open_db();
  const setProgressCircleStateWrapper=(newState)=>setProgressCircleState(newState)
  const setPageNameWrapper=(newState)=>{
      setPageName(newState)
      if(newState === "Home" && window.modelsLoaded!==true)
      {
        window.loadModels();
      }

    }
  const setdrawerStateWrapper=(newState)=>setdrawerState(newState)
  useEffect(() => {
    window.enqueueSnackbar=enqueueSnackbar;
    if (render_count === 0) {
      window.modelsLoaded = false
      if(!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
      {
        window.devMode && console.log("this development Mode")
        window.devMode=true
      }
      else
      {
        window.devMode && console.log("this production Mode")
        window.devMode=false
      }
      
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/service-worker.js')
          .then((registration) => {
            console.log('Service Worker registered with scope:', registration.scope);
          })
          .catch((error) => {
            console.error('Service Worker registration failed:', error);
          });
      }
      // volanteer.volanteer_scheduler();
      window.current_page=pageName
      window.loadModels = async () => {
        const MODEL_URL = process.env.PUBLIC_URL + '/models';
        window.devMode && console.log("loading models");
        setProgressCircleState('progress')
        Promise.all([
          window.faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
          window.faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
          window.faceapi.nets.ssdMobilenetv1.loadFromUri(MODEL_URL),
          // window.faceapi.nets.faceExpressionNet.loadFromUri(MODEL_URL),
        ]).then(
          setModelsLoaded(true),
          window.modelsLoaded = true,
          window.devMode && console.log("models loaded"),
          setProgressCircleState('done')
        ).catch(err => window.devMode && console.log(err));
      }
      // loadModels();
      serviceWorkerRegistration.register()
    }
    render_count++;
    window.devMode && console.log(`render_count ${render_count}`)
}, []);
  const AppCTRL=
  {
    Bar:{/*progressCircleState,*/setProgressCircleStateWrapper},
    Body:{/*pageName,*/setPageName:setPageNameWrapper},
    Drawer:{ /*drawerState,*/ setdrawerState},
    // FaceAPIWorker:{get_face_discribtor},
  }

    
  // and the controller will be an object encapsulate worker methods and function from old app.js
  const drawerOpenerCallback=(e)=>setdrawerState((pageName === 'Login' || pageName === 'SignUp') ? {...drawerState,left:false} : {...drawerState,left:true})
  return ( //TODO: consider login view
    <div className="App">
      <ReduxProvider store={store}>
        <AppGlobalContext.Provider value={AppCTRL}>
          <SnackbarProvider maxSnack={5} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} autoHideDuration={2000}>
            {/* SnackbarProvider is used to show notifications */}
          <div >
          <CustomAppBar
            hidden={(pageName === 'Login' || pageName === 'SignUp') ? true : false} 
            title={pageName}
            drawerOpener={drawerOpenerCallback}
            progressCircleState={progressCircleState} />
          </div>
          <AppBody page={pageName} />
          <ResponsiveDrawer drawerState={drawerState} setDrawerState={setdrawerState} setPageName={setPageName} />
          <BottomNav 
            currentPage={pageName} 
            onPageChange={setPageName}
            hidden={(pageName === 'Login' || pageName === 'SignUp' || pageName === 'Profile')}
          />
          </SnackbarProvider>
        </AppGlobalContext.Provider>
      </ReduxProvider>
    </div>
  );
}

export default App;
